// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"ce622817","139":"6bc5557a","266":"0d528076","653":"33d2343a","736":"129f8297","890":"f8145658","960":"d86a68ac"}[chunkId] + ".chunk.js";
};